<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StepLayout',

  props: {
    /**
     * 必須かどうか
     */
    required: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['click:prev'],
})
</script>

<template>
  <div class="l-unit__signUpStep">
    <div class="l-unit__signUpStep--header">
      <div class="o-heading__signUpStep">
        <h2 class="o-heading__signUpStep--item is-primary">
          <span class="o-heading__signUpStep--label is-title">
            <slot name="title" />
          </span>
          <span
            v-if="required"
            class="o-heading__signUpStep--label is-required">
            必須
          </span>
        </h2>
        <p class="o-heading__signUpStep--item is-secondary">
          <slot name="caption" />
        </p>
      <!-- /.o-heading__signUpStep --></div>
    <!-- /.l-unit__signUpStep header --></div>

    <div class="l-unit__signUpStep--description">
      <slot name="description" />
    <!-- /.l-unit__signUpStep description --></div>

    <div class="l-unit__signUpStep--action is-prev">
      <div class="o-action__prev">
        <button
          class="o-action__prev--item"
          @click.prevent="$emit('click:prev')">
          戻る
        </button>
      <!-- /.o-action__prev --></div>
    <!-- /.l-unit__signUpStep action --></div>
  <!-- /.l-unit__signUpStep --></div>
</template>

<style lang="sass" scoped>
.l-unit__signUpStep
  $step-counter-width: 3em
  $column-gap: changeSizePx2Em(10)
  display: grid
  grid-template-columns: auto 1fr calc($step-counter-width + $column-gap)
  grid-template-rows: auto 1fr
  column-gap: $column-gap
  row-gap: 1.5em
  padding: 1.5em 3em

  & &--header
    grid-column: 2 / 3
    grid-row: 1 / 2

  & &--description
    grid-column: 1 / 4
    grid-row: 2 / 3

  & &--action
    &.is-prev
      grid-column: 1 / 2
      grid-row: 1 / 2

  +breakpoint
    padding:
      left: 1.5em
      right: 1.5em

.o-heading__signUpStep
  & &--item
    &.is-secondary
      font-size: $font-small
      margin-top: 0.5em

  & &--label
    vertical-align: middle

    &.is-title
      line-height: 1.4
      font-size: $font-large

    &.is-required
      display: inline-block
      line-height: 1
      color: $font-white
      font:
        size: $font-x-small
        weight: normal
      white-space: nowrap
      margin-left: changeSizePx2Em(4, $font-x-small-px)
      padding: changeSizePx2Em(2.4, $font-x-small-px) changeSizePx2Em(4.6, $font-x-small-px)
      background-color: rgba($bg-green, 1)
      border-radius: $border-radius

.o-action__prev
  $heading-font-size-rem: 1.8
  $heading-line-height: 1.4
  $button-height: $heading-font-size-rem * $heading-line-height
  & &--item
    width: 1em
    height: #{$button-height}rem
    overflow: hidden
    color: rgba($font-white, 0)
    white-space: nowrap

    &::before
      content: ""
      width: 1em
      height: #{$button-height}rem
      display: block
      color: $font-gray
      background:
        image: url(@/images/icon/icon-prev_01.svg)
        repeat: no-repeat
        position: center center
        size: contain
      +transition

    +mouseover
      &::before
        background-image: url(@/images/icon/icon-prev_hover_01.svg)
</style>
